import api from "../../../config/api/index.js";

// ============================================
// ✅ تراکنش‌های کیف پول کاربر
// GET /api/customerPanel/login/getTransaction
// ============================================
export interface CustomerTransactionParams {
    page?: number;
    size?: number;
    sortField?: string;
    sortDirection?: "ASC" | "DESC" | "ACS" | "DESC";
}
export interface ApiResponse<T> {
    hasError: boolean;
    code: number | null;
    message: string | null;
    payload: T;
    count: number | null;
}
export interface CustomerTransactionItem {
    transactionStatus: string;
    uuid: string;
    groupId: string | null;
    transactionAbout: string;
    transactionDate: string | null;
    releaseDate: string | null;
    paymentDate: string | null;
    paymentDescription: string | null;
    transactionType: string;
    description: string | null;
    count: number | null;
    fee: number | null;
    amount: number | null;
    otherDescription: string | null;
}

export const GetCustomerTransactions = async (
    params: CustomerTransactionParams = {}
): Promise<ApiResponse<CustomerTransactionItem[]>> => {
    try {
        const res = await api.get<ApiResponse<CustomerTransactionItem[]>>(
            "/customerPanel/login/getTransaction",
            {
                params: {
                    page: params.page ?? 0,
                    size: params.size ?? 10,
                    sortField: params.sortField ?? "transactionDate",
                    sortDirection: params.sortDirection ?? "DESC",
                },
            }
        );
        return res.data;
    } catch (err) {
        throw err;
    }
};

// ============================================
// ✅ کیف پول بلاک‌شده
// GET /api/customerPanel/query/searchBlockedTransaction
// ============================================
export const GetBlockedTransactions = async (
    params: CustomerTransactionParams = {}
): Promise<ApiResponse<CustomerTransactionItem[]>> => {
    const res = await api.get<ApiResponse<CustomerTransactionItem[]>>(
        "/customerPanel/query/searchBlockedTransaction",
        {
            params: {
                page: params.page ?? 0,
                size: params.size ?? 25,
                sortField: params.sortField ?? "id",
                sortDirection: params.sortDirection ?? "ASC",
            },
        }
    );
    return res.data;
};